import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center">
            <img 
              src="https://emergentdigitalinklogo.s3.us-east-1.amazonaws.com/logo1.png"
              alt="Digital Ink AI" 
              className="h-8 mr-4"
            />
            <h1 className="text-xl font-semibold text-slate-900">Digital Ink AI</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-2xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 text-center">
          <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-6" />
          
          <h2 className="text-2xl font-bold text-slate-900 mb-4">Payment Cancelled</h2>
          
          <p className="text-slate-600 mb-6">
            You cancelled the payment process. No charges were made to your account.
          </p>

          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-8">
            <div className="flex items-start">
              <CreditCard className="w-5 h-5 text-orange-600 mt-0.5 mr-3 flex-shrink-0" />
              <div className="text-left">
                <h3 className="font-semibold text-orange-900 mb-2">What happened?</h3>
                <p className="text-sm text-orange-800">
                  You chose to cancel the payment process. Your payment method was not charged, 
                  and no subscription or service access was activated.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <button
              onClick={() => navigate(-1)}
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Try Payment Again
            </button>
            
            <button
              onClick={() => navigate('/')}
              className="w-full bg-gray-100 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
            >
              Back to Home
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Need help? Contact our support team at support@digitalinkai.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;